module.exports = __webpack_public_path__ + "img/archi-colin.6c698d46.jpg";